import { usePromisedRequest as promiseRequest } from "../Common/request";
import { resolveWithBody, resolveNoContent } from "./Utils/utils";

export interface ScheduleSettings {
    fightsBreakTime: string;
}

export interface ScheduleSettingsUpdate {
    fightsBreakTime: string;
}

export default {
    get(eventId: number): Promise<ScheduleSettings> {
        return promiseRequest<ScheduleSettings>({
            url: `/api/admin/events/${eventId}/schedules/settings`,
            method: "get",
            json: true,
        }).then(resolveWithBody("Could not get settings."));
    },

    save(eventId: number, scheduleSettingsUpdate: ScheduleSettingsUpdate): Promise<void> {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/schedules/settings`,
            method: "put",
            json: scheduleSettingsUpdate,
        }).then(resolveNoContent("Could not save settings."));
    },
};
